import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useTheme
} from '@mui/material';

export default function PasswordResetPage(backEnd) {
  const { token } = useParams();
  const theme = useTheme();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const navigate = useNavigate();

  const handleResendRequest = async () => {
    if (!email.trim()) {
      setEmailError('Моля въведете имейл.');
      return;
    }

    try {
      setLoading(true);
      setEmailError('');
      // Replace this with your actual request
      const response = await fetch(backEnd.backEnd  + 'password-reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Грешка при заявката');

      setMessage('Заявката е изпратена успешно. Моля проверете Вашия мейл за допълнителна информация');
      setOpenModal(false);
      setTimeout(() => {
  navigate('/login'); // Change '/login' to your desired path
}, 3000);

    } catch (err) {
      setMessage(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage('Паролите не съвпадат.');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(backEnd.backEnd + 'reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token,
          password,
          confirm_password: confirmPassword,
        }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Грешка при заявката');

      setMessage(data.message || 'Успешна смяна на парола.');
      setTimeout(() => {
  navigate('/login'); // Change '/login' to your desired path
}, 3000);

    } catch (err) {
      setMessage(err.message);
      if (err.message.includes('Невалидна оторизация.')) {
        setOpenModal(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          color: theme.palette.text.primary,
          fontWeight: 'bold',
          textAlign: 'center',
        }}
      >
        Смяна на парола
      </Typography>

      {message && (
        <Typography variant="body2" sx={{ color: '#1CA6AF', textAlign: 'center', mb: 2 }}>
          {message}
        </Typography>
      )}

      <form onSubmit={handleSubmit}>
        <TextField
          label="Нова парола"
          type="password"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          sx={{
            '& label': { color: 'gray' },
            '& label.Mui-focused': { color: theme.palette.text.secondary },
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: theme.palette.text.secondary },
              '&:hover fieldset': { borderColor: theme.palette.secondary.main },
              '&.Mui-focused fieldset': { borderColor: theme.palette.primary.secondary },
            },
          }}
        />
        <TextField
          label="Потвърди паролата"
          type="password"
          fullWidth
          margin="normal"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          sx={{
            '& label': { color: 'gray' },
            '& label.Mui-focused': { color: theme.palette.text.secondary },
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: theme.palette.text.secondary },
              '&:hover fieldset': { borderColor: theme.palette.secondary.main },
              '&.Mui-focused fieldset': { borderColor: theme.palette.primary.secondary },
            },
          }}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{
            mt: 2,
            backgroundColor: theme.palette.text.primary,
            color: 'white',
            '&:hover': {
              backgroundColor: 'white',
              color: theme.palette.text.primary,
            },
          }}
          disabled={loading}
        >
          {loading ? 'Изпращане...' : 'Потвърди новата парола'}
        </Button>
      </form>

      {/* Dialog Modal */}
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>Изпрати заявка за промяна на парола</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Оторизацията е невалидна. Моля въведете имейл адрес, за да заявите нова заявка за смяна на парола.
          </Typography>
          <TextField
            label="Имейл"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!emailError}
            helperText={emailError}
            sx={{
            '& label': { color: 'gray' },
            '& label.Mui-focused': { color: theme.palette.text.secondary },
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: theme.palette.text.secondary },
              '&:hover fieldset': { borderColor: theme.palette.secondary.main },
              '&.Mui-focused fieldset': { borderColor: theme.palette.primary.secondary },
            },
          }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)} sx={{
            mt: 2,
            backgroundColor: theme.palette.text.primary,
            color: 'white',
            '&:hover': {
              backgroundColor: 'white',
              color: theme.palette.text.primary,
            },
          }}>
            Затвори
          </Button>
          <Button onClick={handleResendRequest} variant="contained" sx={{
            mt: 2,
            backgroundColor: theme.palette.text.primary,
            color: 'white',
            '&:hover': {
              backgroundColor: 'white',
              color: theme.palette.text.primary,
            },
          }}>
            Заяви
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
